var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54325 6.51173C8.96037 4.17056 11.8719 3 15.2778 3C18.6836 3 21.5814 4.15727 23.971 6.47183C26.3608 8.7864 27.5556 11.5931 27.5556 14.892C27.5556 16.5414 27.1298 18.4303 26.2783 20.5587C25.4268 22.6869 24.3968 24.6824 23.1883 26.5446C21.9797 28.4069 20.785 30.1494 19.6039 31.7723C18.4228 33.3952 17.4202 34.6854 16.5962 35.6432L15.2778 37C14.9482 36.6275 14.5086 36.1355 13.9593 35.5235C13.41 34.9116 12.4212 33.6878 10.9929 31.852C9.56462 30.0164 8.31488 28.234 7.24365 26.5048C6.17245 24.7755 5.19736 22.8201 4.31843 20.6384C3.43947 18.457 3 16.5414 3 14.892C3 11.5931 4.18107 8.7997 6.54325 6.51173Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1668 15.278C17.1668 16.3213 16.3212 17.1669 15.2779 17.1669C14.2347 17.1669 13.389 16.3213 13.389 15.278C13.389 14.2349 14.2347 13.3892 15.2779 13.3892C16.3212 13.3892 17.1668 14.2349 17.1668 15.278Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.ef30dbba9365764e34f20c6f4b9857aa.svg";
export { ForwardRef as ReactComponent };